import React from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import UpgradeButton from '../organization/UpgradeButton';
import { openPricingModal } from '../utils/url/pricingPath';

interface UploadRestrictionUpgradeButtonProps {
  onClick?: () => void;
}

const UploadRestrictionUpgradeButton = ({
  onClick,
}: UploadRestrictionUpgradeButtonProps) => {
  const dispatch = useAppDispatch();
  const handleUpgradeClick = () => {
    openPricingModal(dispatch, 'uploadSize');
    onClick?.();
  };

  return (
    <UpgradeButton
      size="small"
      variant="secondary"
      onClick={() => handleUpgradeClick()}
    >
      View upgrade options
    </UpgradeButton>
  );
};

export default UploadRestrictionUpgradeButton;
